import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { getTransmissionStateByTag } from '../../helpers/get-transmission-states.helper';
import { TransmissionState } from '../../models/transmission-status-information.model';

@Component({
  selector: 'app-tabs-vehicle',
  templateUrl: './tabs-vehicle.component.html',
  styleUrls: ['./tabs-vehicle.component.scss'],
})
export class TabsVehicleComponent implements OnInit, OnChanges {
  public description = '';
  public withIcon = true;
  @Input() variant:
    | 'inMotion'
    | 'idleWithIgnitionOn'
    | 'idleWithoutIgnition'
    | 'noTransmission'
    | 'noSignalCoverage'
    | 'gpsError'
    | 'undefined' = 'undefined';
  // enviar el icon por children un svg
  public variantColor = '';
  public transmissionState: TransmissionState | undefined;

  ngOnInit(): void {
    this.updateState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['variant']) {
      this.updateState();
    }
  }

  private updateState(): void {
    this.transmissionState = getTransmissionStateByTag(this.variant);
    this.variantColor = this.getVariantColor();
    this.description = this.getVariantName();
  }

  private getVariantColor(): string {
    return this.transmissionState?.transmissionStatusColor || '';
  }

  private getVariantName(): string {
    return this.transmissionState?.transmissionStatusName || '';
  }
}
